import { Condition } from "./medication-condition-pairs";

export enum SubDenialReason {
  BMI_DOESNT_MEET_CRITERIA = "BMI_DOESNT_MEET_CRITERIA",
  WEIGHT_LOSS_PROGRAM_DOESNT_MEET_CRITERIA = "WEIGHT_LOSS_PROGRAM_DOESNT_MEET_CRITERIA",
  WEIGHT_LOSS_CARE_NOT_COVERED_AT_ALL = "WEIGHT_LOSS_CARE_NOT_COVERED_AT_ALL",
  MEDICATION_NOT_COVERED_AT_ALL = "MEDICATION_NOT_COVERED_AT_ALL",
  MEDICATION_NOT_COVERED_FOR_MY_DIAGNOSIS = "MEDICATION_NOT_COVERED_FOR_MY_DIAGNOSIS",
  MUST_TRY_OTHER_MEDICATIONS_FIRST = "MUST_TRY_OTHER_MEDICATIONS_FIRST",
  DIDNT_LOSE_ENOUGH_WEIGHT = "DIDNT_LOSE_ENOUGH_WEIGHT",
  LOST_TOO_MUCH_WEIGHT = "LOST_TOO_MUCH_WEIGHT",
  A1C_DOESNT_MEET_CRITERIA = "A1C_DOESNT_MEET_CRITERIA",
  MEDICATION_NOT_CONSIDERED_EFFECTIVE = "MEDICATION_NOT_CONSIDERED_EFFECTIVE",
  INSURER_REQUIRING_MEDICATION_SWITCH = "INSURER_REQUIRING_MEDICATION_SWITCH",
  EXERCISE_OR_DIET_DOESNT_MEET_CRITERIA = "EXERCISE_OR_DIET_DOESNT_MEET_CRITERIA",
  SUCRASE_ACTIVITY_LESS_THAN_10 = "SUCRASE_ACTIVITY_LESS_THAN_10",
  BOWEL_BIOPSY_NOT_PERFORMED = "BOWEL_BIOPSY_NOT_PERFORMED",
  GENETIC_TESTING_REQUIRED = "GENETIC_TESTING_REQUIRED",
  POSITIVE_SUCRAID_RESPONSE_CONTINUATION = "POSITIVE_SUCRAID_RESPONSE_CONTINUATION",
  OBESITY_PLAN_EXCLUSION_ALTERNATIVE_CONDITION = "OBESITY_PLAN_EXCLUSION_ALTERNATIVE_CONDITION",
}

export const subDenialReasonOptionsByCondition: Record<
  | Condition.OBESITY
  | Condition.TYPE_2_DIABETES
  | Condition.CSID
  | Condition.OBSTRUCTIVE_SLEEP_APNEA
  | Condition.MASH,
  { [key in SubDenialReason]?: string }
> = {
  [Condition.OBESITY]: {
    [SubDenialReason.BMI_DOESNT_MEET_CRITERIA]:
      "BMI doesn't meet  payer's criteria",
    [SubDenialReason.WEIGHT_LOSS_PROGRAM_DOESNT_MEET_CRITERIA]:
      "Weight loss program doesn't meet criteria",
    [SubDenialReason.WEIGHT_LOSS_CARE_NOT_COVERED_AT_ALL]:
      "Weight loss care not covered at all",
    [SubDenialReason.MEDICATION_NOT_COVERED_AT_ALL]:
      "Medication not covered at all",
    [SubDenialReason.MEDICATION_NOT_COVERED_FOR_MY_DIAGNOSIS]:
      "Medication not covered for my diagnosis",
    [SubDenialReason.MUST_TRY_OTHER_MEDICATIONS_FIRST]:
      "Must try other medications first",
    [SubDenialReason.DIDNT_LOSE_ENOUGH_WEIGHT]: "Didn't lose enough weight",
    [SubDenialReason.LOST_TOO_MUCH_WEIGHT]: "Lost too much weight",
  },
  [Condition.TYPE_2_DIABETES]: {
    [SubDenialReason.A1C_DOESNT_MEET_CRITERIA]:
      "A1c doesn't meet payer's criteria",
    [SubDenialReason.EXERCISE_OR_DIET_DOESNT_MEET_CRITERIA]:
      "Exercise or diet doesn't meet plan criteria",
    [SubDenialReason.MUST_TRY_OTHER_MEDICATIONS_FIRST]:
      "Must try other medications first",
    [SubDenialReason.MEDICATION_NOT_CONSIDERED_EFFECTIVE]:
      "Medication was not considered effective",
    [SubDenialReason.MEDICATION_NOT_COVERED_AT_ALL]:
      "Medication not covered at all by my plan",
  },
  [Condition.CSID]: {
    [SubDenialReason.SUCRASE_ACTIVITY_LESS_THAN_10]: "Sucrase activity <10U/g",
    [SubDenialReason.BOWEL_BIOPSY_NOT_PERFORMED]:
      "Bowel biopsy not performed (Disaccharidase Assay)",
    [SubDenialReason.GENETIC_TESTING_REQUIRED]: "Genetic testing required",
    [SubDenialReason.POSITIVE_SUCRAID_RESPONSE_CONTINUATION]:
      "Positive sucraid response/continuation",
  },
  [Condition.OBSTRUCTIVE_SLEEP_APNEA]: {
    [SubDenialReason.OBESITY_PLAN_EXCLUSION_ALTERNATIVE_CONDITION]:
      "Originally denied for Obesity plan exclusion",
  },
  [Condition.MASH]: {
    [SubDenialReason.OBESITY_PLAN_EXCLUSION_ALTERNATIVE_CONDITION]:
      "Originally denied for Obesity plan exclusion",
  },
};
